import {getLocalStorageValue} from '../../../utils/storeUtil'

export default {
    name: 'UI',
    state: {
        testString: 'test 1',
    },
    mutations: {
        initiateUI: (state, value) => {
            const keysToRetrieve = [
                { key: 'testString', type: 'string' },
            ];

            keysToRetrieve.forEach(({ key, type }) => {
                const { hasValue, returnValue } = getLocalStorageValue(key, type);

                if (hasValue) {
                    if (hasValue) state[key] = returnValue;
                }
            });

        },
        setTestString: (state, value) => {
            state.testString = 'test ' + value;
            localStorage.setItem('testString', state.testString);
        },
    },
    getters: {
        testString(state) {
            return state.testString;
        },
    },
}
